// extracted by mini-css-extract-plugin
module.exports = {"mSizingGuide":"Ko","top":"Lo","sizeTable":"Mo"};